import React from 'react';
import Button from 'src/ui/library/Button';
import intl from 'react-intl-universal';
import classNames from 'classnames';

export default function ActionsBarPres({
  pageCount,
  pageNumber,
  isNextDisabled,
  isSubmitDisabled,
  isFirstPage,
  isLastPage,
  onNextPage,
  onPrevPage,
  onSubmit,
}) {
  const progressBarWidth = (1 / pageCount) * 100;
  return (
    <section className="ssi-actions">
      <div className="ssi-progress-wrapper">
        <span className="progress-text">
          Progress: Consent {pageNumber} of {pageCount}
        </span>
        <div className="progress-bar transparent">
          {[...Array(pageCount)].map((x, i) => {
            const width = i === pageCount - 1 ? `${progressBarWidth}%` : `calc(${progressBarWidth}% - 2px)`;
            const spanClass = classNames({
              filled: true,
              'filled-black': true,
              active: i < pageNumber,
            });
            return <span key={i} className={spanClass} style={{ width }} />;
          })}
        </div>
      </div>
      <div className="ssi-button-wrapper">
        <div className="ssi-wrapper-nextprevious">
          <Button styleType="secondary" disabled={isFirstPage} onClick={onPrevPage} className="action-button">
            &lt;&nbsp;{intl.get('serviceInit.addInit.actionBar.back')}
          </Button>
          {!isLastPage && (
            <Button styleType="secondary" disabled={isNextDisabled} onClick={onNextPage} className="action-button">
              {intl.get('serviceInit.addInit.actionBar.next')}&nbsp;&gt;
            </Button>
          )}
          {isLastPage && (
            <Button styleType="primary" disabled={isSubmitDisabled} onClick={onSubmit} className="action-button">
              {intl.get('serviceInit.addInit.actionBar.submit')}
            </Button>
          )}
        </div>
      </div>
    </section>
  );
}
